import { z } from 'zod';
export const CreateCherryPickInput = z.object({
    repoId: z.string().min(1),
    sourceSha: z.string().min(7),
    targetSha: z.string().min(7),
    note: z.string().max(500).optional(),
});
export const UpdateCherryPickInput = z.object({
    note: z.string().max(500).nullable(),
});
//# sourceMappingURL=cherryPick.js.map